class CountryProvinceSelector extends HTMLElement {
  connectedCallback() {
    this.formID = this.dataset.formId;
    this.countrySelector = `AddressCountry_${this.formID}`;
    this.provinceSelector = `AddressProvince_${this.formID}`;
    this.provinceContainer = `AddressProvinceContainer_${this.formID}`;

    this.init();
  }

  init() {
    const countryElement = document.getElementById(this.countrySelector);
    const provinceContainerElement = document.getElementById(this.provinceContainer);

    new Shopify.CountryProvinceSelector(this.countrySelector, this.provinceSelector, {
      hideElement: null,
    });

    const toggleProvince = () => {
      const hasProvinces =
        countryElement.options[countryElement.selectedIndex].getAttribute('data-provinces') !==
        '[]';
      provinceContainerElement.classList.toggle('hidden', !hasProvinces);
    };

    countryElement.addEventListener('change', toggleProvince);
    toggleProvince();
  }
}

if (!customElements.get('country-province-selector'))
  customElements.define('country-province-selector', CountryProvinceSelector);
